import InlineTextInput from '@/components/ui/inline-text-input';
import { pdkAxios } from '@/lib/pdk-axios';
import type { Trade } from '@/models/types';
import { tradesStore } from '@/stores/trades-store';
import { useMutation } from '@tanstack/react-query';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

const TradeStateEditor = ({
  tradeId,
  initialState,
}: {
  tradeId: Trade['id'];
  initialState: string;
}) => {
  const [state, setState] = useState(initialState);

  const updateStateMutation = useMutation({
    onMutate: async ({ state }: { state: string }) => {
      tradesStore.updateTrade(tradeId, {
        state: state,
      });
    },
    mutationFn: async ({ state }: { state: string }) => {
      const response = await pdkAxios.post(
        `/trades/${tradeId}/state`,
        // /api/trades/:trade_id/state
        {
          state: state,
        },
      );

      return response.data;
    },
    onSuccess: () => {},
    onError: (error, variables) => {
      console.error('Error updating state', error, variables);
      // TODO: handle error by adding the original cdkId back to the store
    },
  });

  const handleStateChange = useCallback(
    debounce((newState: string) => {
      updateStateMutation.mutate({ state: newState });
    }, 1000),
    [],
  );

  useEffect(() => {
    if (state === initialState) return;

    handleStateChange(state);
  }, [state]);

  const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setState(e.target.value);
  }, []);

  useEffect(() => {
    setState(initialState);
  }, [initialState]);

  return (
    <div className="flex flex-row gap-1 items-center justify-between">
      <div className="flex flex-row gap-1 items-center">
        <div className="text-sm text-gray-500 dark:text-white">State</div>
      </div>
      <InlineTextInput
        value={state}
        onChange={onChange}
        placeholder="Enter state"
        className="text-right"
        wrapperClassName="gap-1"
      />
    </div>
  );
};

export default TradeStateEditor;
